import { render, staticRenderFns } from "./MunicipalOrg.vue?vue&type=template&id=1f06b5e4&"
import script from "./MunicipalOrg.vue?vue&type=script&lang=ts&"
export * from "./MunicipalOrg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports